import { twMerge } from 'tailwind-merge';

const defaultClasses =
    'skeleton-heroui-port group pointer-events-none relative overflow-hidden bg-content3 !duration-300 transition-background before:absolute before:inset-0 before:animate-[shimmer_2s_infinite] before:border-t before:border-content4/30 before:bg-gradient-to-r before:from-transparent before:via-content4 before:to-transparent before:opacity-100 after:absolute after:inset-0 after:-z-10 after:bg-content3 after:opacity-100 data-[loaded=true]:pointer-events-auto data-[loaded=true]:overflow-visible data-[loaded=true]:!bg-transparent data-[loaded=true]:before:-z-10 data-[loaded=true]:before:animate-none data-[loaded=true]:before:opacity-0 data-[loaded=true]:after:opacity-0 dark:bg-content2 dark:before:via-default-700/10 dark:after:bg-content2';
const childrenContainerClasses =
    'opacity-0 group-data-[loaded=true]:opacity-100 transition-opacity motion-reduce:transition-none !duration-300';

export function Skeleton({ className, children }: { className?: string; children?: React.ReactNode }) {
    return (
        <div className={twMerge(defaultClasses, className)}>
            <div className={childrenContainerClasses}>{children && children}</div>
        </div>
    );
}
